// Filter of UiComboBox: every word typed must appear in the label, in any order, ignoring case and accents.
// "gpt 4o" finds "openai/gpt-4o-mini"; "sao" finds "São Paulo".
const fold = (text: string) => text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()

export function filterOptions<T extends { label: string }>(options: ReadonlyArray<T>, query: string): T[] {
  const words = fold(query).split(/\s+/).filter(Boolean)
  if (!words.length) return [...options]
  return options.filter((option) => {
    const label = fold(option.label)
    return words.every((word) => label.includes(word))
  })
}
